import React, { Component } from 'react';
import { withStyles, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import ReactGA from 'react-ga';

import Slide from '@material-ui/core/Slide';

const styles = theme => ({
  body: {
    color: '#000000'
  }
});
function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class Premiere extends Component {
  state = {
    open: false
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;
    const { open } = this.state;

    return (
      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          fullWidth
          maxWidth="sm"
          keepMounted
          onClose={this.handleClose}
        >
          {/* <DialogTitle>
            <Typography variant="h2" align="center">
              The Grand Premiere!!!
            </Typography>
          </DialogTitle> */}
          <DialogContent>
            <a
              style={{ color: '#00a8c2' }}
              href="https://www.facebook.com/events/434960430666484/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                ReactGA.ga(
                  'send',
                  'event',
                  'fbevent',
                  'fbEventClick',
                  'fbImage'
                );
              }}
            >
              <img
                src="/images/premiere.jpg"
                alt="The Grand Premiere - May 31st"
              />
            </a>
            <br />
            {/* <DialogContentText> */}
            <Typography variant="h5">
              Join our{' '}
              <a
                style={{ color: '#00a8c2' }}
                href="https://www.facebook.com/events/434960430666484/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  ReactGA.ga(
                    'send',
                    'event',
                    'fbevent',
                    'fbEventClick',
                    'fbLink'
                  );
                }}
              >
                FB event
              </a>{' '}
              to be sure you don't miss it!
            </Typography>
            {/* </DialogContentText> */}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              AWESOME
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(Premiere);
